module.exports = __webpack_public_path__ + "img/hammam_MAD.6bcb1b75.jpg";